namespace advisorop.components.advisor {

    export class PerformanceGridPtpController {
        performanceDetails: Array<any>;
        rtgId: number;
        showNeto: boolean = true;
        hideSleeves: boolean = false;
        dg: DevExpress.ui.dxDataGridOptions;

        // instance of performance grid
        dgPerformanceGridPtp: DevExpress.ui.dxDataGrid;

        constructor(private advisorService: services.AdvisorService) {

            this.dg = {
                export: {
                    enabled: false,
                    fileName: "PerformanceDetails"
                },
                bindingOptions: {
                    dataSource: "vm.performanceDetails"
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    //pageSize: 5,
                    enabled: false
                },
                rowAlternationEnabled: false,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgPerformanceGridPtp = e.component;
                },
                wordWrapEnabled: true,

                columns: [

                    { dataField: "groupDescription", caption: "", width: 500 },
                    { dataField: "ptpAnnValue", caption: "Performance (Annualized)", format: { type: "percent", precision: 2 }, alignment: 'right' },
                    { dataField: "ptpValue", caption: "Performance (Cumulative)", format: { type: "percent", precision: 2 }, alignment: 'right' },
                ],
                masterDetail: {
                    enabled: true,
                    template: "detail",
                    autoExpandAll: true
                }
            };

        }

        onc3 = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                //console.log('yyyyyyy: ', e);
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        $onInit(): void {
        }

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "performanceDetails" && this.performanceDetails) {
                    //console.log("Performance details data: ");
                    //console.log(this.performanceDetails);
                }
            }
        };

    }



    class PerformanceGridPtp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;


        constructor() {
            this.bindings = {
                performanceDetails: "<"
            };
            this.controller = ["advisorService", PerformanceGridPtpController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/performance-grid-ptp.html";
        }
    }
    angular.module(Constants.APP).component("performanceGridPtp", new PerformanceGridPtp());

}